import * as React from 'react';
import MyMarker from '../../components/Marker';
import { ObjectCard } from '../../components/ObjectCard';
import { Box } from '@mui/system';
import { titleCase } from 'title-case';
import  TmcChart  from './TmcChart'

const endpoint = "assetsignals";

const showCardContent = (obj) => { return true }

const ModuleMarker = (props) => {

    const count = props.icon.totalVehicleCountYesterday;

    if(count > 1){
        return (
            <MyMarker {...props} icondef={getCountIcon()} />
        )
    }else{
        return (
            <MyMarker {...props} icondef={getIcon()} />
        )
    }
}

const getIcon = () => {
    return {
        url: "/mapicons/signal/signal.png",
        anchor: new window.google.maps.Point(4, 10),
        scaledSize: new window.google.maps.Size(11, 27)
    };
}
const getCountIcon = () => {
    return {
        url: "/mapicons/signal/signalTmcBlue.png",
        anchor: new window.google.maps.Point(20, 15),
        scaledSize: new window.google.maps.Size(32, 32)
    };
}

const CardContent = (props) => {
    const obj = props.obj;
    const count = obj.totalVehicleCountYesterday;
    const northCount = obj.totalToNorth;
    const westCount = obj.totalToWest;
    const eastCount = obj.totalToEast;
    const southCount = obj.totalToSouth;
    const northEastCount = obj.totalToNorthEast;
    const northWestCount = obj.totalToNorthWest;
    const southEastCount = obj.totalToSouthEast;
    const southWestCount = obj.totalToSouthWest;

    
    if(count > 1){
        return (
           <>
             <Location value={obj} />
             <AbsoluteAddress value={obj}/>
             <VehicleCount value={obj}/>
             <TmcChart totalCount={count} northCount={northCount} westCount={westCount} eastCount={eastCount}
             southCount={southCount} northEastCount={northEastCount} northWestCount={northWestCount} southEastCount={southEastCount} southWestCount={southWestCount} />
         </>
     )
     }else{
        return (
            <>
                <Location value={obj} />
                <AbsoluteAddress value={obj}/>
                <VehicleCount value={obj}/>
            </>
        )
        }
    
}

const VehicleCount = props => {
    const count = props.value.totalVehicleCountYesterday;
    var vehCountString = "Vehicle Count (";
    if(count > 1){

        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);

        const formattedDate = `${yesterday.getMonth() + 1}/${yesterday.getDate()}/${yesterday.getFullYear()}`;
        vehCountString += formattedDate + "): " + count;

        //vehCountString += count;
        return (
           <Box>{vehCountString}</Box> 
        )
    }else{
        return (
            <div></div>
        )
    }
}

const AbsoluteAddress = props => {
    const obj = props.value;
    var absAddress = "";
    if(obj.nsAddress) {
        absAddress += obj.nsAddress;
    }
    if(obj.ewAddress) {
        if(absAddress !== "") {
            absAddress += " / "
        }
        absAddress += obj.ewAddress;
    }
    return (
        <Box>{absAddress}</Box>
    )
}

const Location = props => {
    const obj = props.value;
    if(obj.name) {
        return (
            <Box sx={{ fontWeight: 'bold'}}>{titleCase(obj.name.toLowerCase())}</Box>
        )
    } else {
        return null;
    }

}

const InfoWindow = (props) => {
    const module = props.module;
    const obj = props.icon;
    const MyCardContent = module.cardContent;
    const showCardContent = module.showCardContent;

    return (
        <div className="infoWindow center"><div>Traffic Signal</div>
            {showCardContent(obj) ?
                <div className="spacer"><MyCardContent obj={obj} /></div>
                :
                null}
        </div>
    )
}

export default {
    name: 'Signals',
    label: 'Traffic Signal #',
    marker: ModuleMarker,
    showOnMap: true, //show on map layer filter
    mapLayerIcon: "/mapicons/signal/signal.png",
    showOnSidebar: false,
    sideBarCard: ObjectCard,
    endpoint: endpoint,
    defaultOn: false,
    updateDelay: 60,
    showCardContent: showCardContent,
    cardContent: CardContent,
    infoWindow: InfoWindow,
    cluster: true,
    clusterMarker: "/mapicons/signal/signal",
    clusterClass: "signal-cluster",
    publishLayer: "tasWebapp.signals.enable"
}